import { render, staticRenderFns } from "./productLayout4.vue?vue&type=template&id=017d508e&"
import script from "./productLayout4.vue?vue&type=script&lang=ts&"
export * from "./productLayout4.vue?vue&type=script&lang=ts&"
import style0 from "./productLayout4.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports